import { Check, X } from "lucide-react";
import { useActions } from "../../hooks/useActions";
import { knifeCut } from "../../engine/knife";
import { fmtIn, bbox } from "../../engine/geometry";

// Floating controls while the trim-knife line is being drawn across the selected decal.
export const KnifeBar = () => {
  const { state, sel, applyKnife, cancelKnife } = useActions();
  const k = state.knife;
  if (!k || !sel) return null;
  const res = k.a && k.b ? knifeCut(sel, k.a, k.b) : null;
  return (
    <div className="absolute left-1/2 top-9 z-20 flex -translate-x-1/2 items-center gap-2 whitespace-nowrap rounded-full border border-[#e5484d]/60 bg-[#121824]/95 px-3 py-1 text-[11px] text-[#d0d3d8] shadow-lg" data-testid="knife-bar">
      <span className="font-semibold text-[#ff8a8e]">Trim knife</span>
      <span className="text-[#9aa0a8]">{k.a ? "drag the end points to adjust · Shift snaps the angle" : "drag a straight line across the graphic"}</span>
      {res && <><span className="mx-1 h-4 w-px bg-[#27324a]" /><span className="font-mono text-[#4c9ffe]" data-testid="knife-sizes">{fmtIn(bbox(res.L.points).w)} × {fmtIn(bbox(res.L.points).h)} · {fmtIn(bbox(res.R.points).w)} × {fmtIn(bbox(res.R.points).h)}</span></>}
      <span className="mx-1 h-4 w-px bg-[#27324a]" />
      <button data-testid="knife-apply-btn" className="btn-red h-6 px-2 py-0 text-[11px]" disabled={!res} onClick={applyKnife}><Check className="h-3 w-3" /> Cut</button>
      <button data-testid="knife-cancel-btn" className="rounded px-1 text-[#9aa0a8] hover:bg-[#27324a] hover:text-white" title="Cancel (Esc)" onClick={cancelKnife}><X className="h-3.5 w-3.5" /></button>
    </div>
  );
};
